module.exports = __webpack_public_path__ + "static/media/Cascades-Northville.30f85b67.pdf";